import fundsClient from 'src/api/fundsClient';
import appConfig from 'src/config';

const baseUrl = `${appConfig.FUNDS_API}${appConfig.NETDOCS_API_PATH}api/v1/`;

export const oauthLogin = async (authCode) => fundsClient.post(`${baseUrl}oauth/login`, { authCode });

export const hasActiveNetdocsLogin = async () => fundsClient.get(`${baseUrl}oauth/login`);

export const searchDocuments = async (_, { attributeType, resourceId }) => {
  const { data } = await fundsClient.get(`${baseUrl}search/${attributeType}/${resourceId}`);
  return data;
};
